
<template>
  <div class="clue-info-right">
    <div class="member-info">
      <i
        class="iconfont iconicon-test15 hide-show-btn"
        :class="{'clue-member-hide':!isShow}"
        @click="hideHandle"
      />
      <a-form>
        <a-form-item label="线索状态：">
          {{ followStatus }}
          <a
            v-if="(followData.status * 1 === 1 || followData.status * 1 === 3 ||followData.status * 1 === -3) && isFollowRight"
            href="javascript:;"
            class="clue-info-tool-btn"
            @click="handlerDetail('sign')"
          >标记无效</a>
          <a
            v-if="(followData.status * 1 === 1 || followData.status * 1 === 3 ||followData.status * 1 === -3||followData.status * 1 === -1 || followData.status * 1 === -2) && isFollowRight"
            href="javascript:;"
            class="clue-info-tool-btn"
            @click="handlerDetail('create')"
          >转为信息</a>
          <a
            v-if="followData.status * 1 === 2 && !!followData.inquiryid"
            href="javascript:;"
            class="clue-info-tool-btn"
            @click="toInquryInfo"
          >查看信息</a>
          <a
            v-if="(followData.status * 1 === -1 || followData.status * 1 === -2) && isFollowRight"
            href="javascript:;"
            @click="handlerDetail('repeatFollow')"
          >重新跟进</a>
        </a-form-item>
        <template v-if="isShow">
          <a-form-item label="跟进人员：">
            {{ followData.dev_truename }}
            <span
              v-if="followData.dev_rolename || followData.dev_groupname"
              class="clue-member-team"
            >[<template v-if="followData.dev_rolename">{{ followData.dev_rolename }}</template><template v-if="followData.dev_groupname">/{{ followData.dev_groupname }}</template>]</span>
          </a-form-item>
          <a-form-item label="录入时间">
            {{ followData.input_date }}
          </a-form-item>
          <a-form-item label="录入人员：">
            {{ followData.input_truename }}
            <span
              v-if="followData.input_groupname || followData.input_rolename "
              class="clue-member-team"
            >[<template v-if="followData.input_rolename">{{ followData.input_rolename }}</template><template v-if="followData.input_groupname">/{{ followData.input_groupname }}</template>]</span>
          </a-form-item>
        </template>
      </a-form>
    </div>
    <div
      class="tabs"
    >
      <div
        ref="tabNavParent"
        class="tab-nav"
      >
        <ul
          class="nav-bar clearfix"
        >
          <template v-for="(item) in tabDatas">
            <li
              v-show="item.show"
              :key="item.fieldkey"
              :class="{'active': item.fieldkey === selected}"
              @click="tabNavChange(item.fieldkey, $event)"
            >
              {{ item.fieldname }}
            </li>
          </template>
        </ul>
      </div>

      <!-- 评论，回访-->
      <div class="containerScroll">
        <component
          :is="tabDatas[selected].component"
          v-if="!loading && tabDatas[selected]"
          ref="content"
          :data="tabDatas[selected].data"
          :is-follow-right="isFollowRight"
          class="module"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex'
// import TabNav from '@/components/pc/TabNav'
// import MyForm from './Form'
import ClueRemarks from './ClueRemarks'
import CommentContent from './CommentContent'
import eventBus from '@/lib/eventBus'

export default {
  components: {
    ClueRemarks,
    CommentContent
  },
  /* props: {
    detailData: {
      type: Object,
      default: () => { }
    }
  }, */
  data () {
    return {
      selected: '',
      loading: false,
      addReturnType: 'add',
      isShow: true
    }
  },
  computed: {
    ...mapGetters('inquery/detailData', ['formData']),
    ...mapState(['baseinfo']),
    from () { // all, my, audit, checkrepeat
      if (this.$route.name === 'InqueryCreate') { // 录入信息
        return 'input'
      } else { // 信息详情
        return this.$route.query.from
      }
    },
    info () {
      const { info = {} } = this.formData
      return info
    },
    pid () {
      return this.$route.params.pid
    },
    followData () {
      const { data = {} } = this.info
      return data
    },
    followStatus () {
      const { status = 1 } = this.followData
      let str = '跟进中'
      if (status === 1) {
        str = '跟进中'
      } else if (status === 2) {
        str = '转为信息'
      } else if (status === -3) {
        str = '跟进中[疑似无效]'
      } else {
        str = '无效'
      }
      return str
    },
    /* tab2 () {
      return this.$route.query.tab2 || 'returnVisite'
    }, */
    tabDatas () {
      let data = {
        followReocord: {
          fieldkey: 'followReocord',
          fieldname: '跟进记录',
          component: CommentContent,
          data: this.info,
          show: true
        },
        clueRemark: {
          fieldkey: 'clueRemark',
          fieldname: '线索备注',
          component: ClueRemarks,
          data: this.info,
          show: true
        }
      }
      return data
    },
    userid () {
      const { userid = '' } = this.baseinfo
      return userid + ''
    },
    isFollowRight () {
      const { dev_userid: devUserid = '' } = this.info
      const { userid = '' } = this
      return devUserid + '' && devUserid + '' === userid
    }
  },
  watch: {
    tabDatas: {
      handler (val) {
        if (!this.selected) {
          let arr = Object.values(val)
          this.selected = arr.find(item => item.show).fieldkey
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.setNavStyle()
      document.querySelector('.clue-container .container-right .nav-bar li').click()
    })
    window.addEventListener('resize', this.setNavStyle)
    document.addEventListener('scroll', this.setNavStyle)
  },
  beforeDestroy () {
  },
  methods: {
    ...mapActions('inquery/clue', ['finishSign', 'repeatFollowClue']),
    tabNavChange (k, ev) {
      this.selected = k
      setTimeout(() => {
        this.setNavStyle()
      }, 100)
      /* this.$router.push({
        query: {
          ...this.$route.query,
          tab2: k
        }
      }) */
    },
    handleAdd () {
      if (this.selected === 'ClueRemarks') {
        this.$refs.content && this.$refs.content.addVisite()
        this.addReturnType = 'edit'
      } else if (this.selected === 'commentContent') {
        this.$refs.content && this.$refs.content.addComment()
      }
    },
    setNavStyle () {
      let containerRight = document.querySelector('.clue-container .container-right')
      let $containerScroll = containerRight && containerRight.querySelector('.containerScroll')
      let memberInfo = containerRight && containerRight.querySelector('.member-info')
      let $navBar = document.querySelector('.clue-container .container-right .nav-bar')
      if ($containerScroll) {
        const h = containerRight.clientHeight - 80 - memberInfo.clientHeight - 40
        $containerScroll.style.height = h + 'px'
      }

      $containerScroll && $containerScroll.addEventListener('scroll', () => {
        const scrollTop = $containerScroll.scrollTop
        $containerScroll.style.height = containerRight.clientHeight - 80 - memberInfo.clientHeight - 40 + 'px'
        if ($navBar && $containerScroll && scrollTop > 0) {
          $navBar.style.borderBottom = 'solid 1px #ebebeb'
        } else {
          $navBar.style.borderBottom = 'none'
        }
      }, false)
    },
    hideHandle () {
      this.isShow = !this.isShow
    },
    async handlerDetail (type) {
      const { clue_id: id } = this.info
      const { query } = this.$route
      let chain = null
      if (type === 'sign') {
        chain = await this.finishSign({ ...query, isdetail: true })
        chain.params({ id, clueid: id }).onSuccess(raw => {
          // this.info.status = -1
          // this.followData.status = -1
          // this.$forceUpdate()
          eventBus.$emit('fetchInquiryDetail')
        }).fetch()
      } else if (type === 'create') {
        this.$router.push({
          path: `/project/${this.pid}/inquery/create`,
          query: {
            clue_id: id,
            from: 'clue'
          }
        })
      } else if (type === 'repeatFollow') {
        chain = await this.repeatFollowClue({ ...query, isdetail: true })
        chain.params({ id, clueid: id }).onSuccess(raw => {
          // console.log(this.info)
          // this.info.status = 1
          // this.followData.status = 1
          // this.$forceUpdate()
          eventBus.$emit('fetchInquiryDetail')
        }).fetch()
      }
    },
    toInquryInfo () {
      const item = this.info
      this.$router.push({
        // path: `/project/${this.pid}/inquery/detail/${inquiryid}`,
        name: item.status * 1 === 1 ? 'InqueryPassDetail' : 'InqueryDetail',
        params: {
          pid: this.pid,
          inquiryId: item.inquiryid
        },
        query: {
          from: 'clue',
          clue_id: item.clue_id
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.tabs {
  position: relative;
  border-top: 1px solid #EBEBEB;
  margin: 0 -40px;

  padding: 72px 40px 0;
  // .containerScroll{
  //   height: calc(100% - 390px) !important;
  // }
  .tab-nav {
    position: absolute;
    top: 0;
    left: 40px;
    width: 100%;
    height: 48px;
    background-color: #fff;
    li {
      position: relative;
      float: left;
      margin-right: 24px;
      height: 47px;
      line-height: 47px;
      font-size: 18px;
      font-weight: bold;
      cursor: pointer;
      &.active {
        color: $primary-color;
        border-bottom: solid 2px $primary-color;
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }
  ::v-deep .nav-wrap {
  overflow: initial;
  }
  ::v-deep .nav-bar {
    margin-right: -40px;
    // border-bottom: solid 1px #ebebeb;
    li {
      position: relative;
      top: 1px;
    }
  }
  .containerScroll {
     height: 100%;
    overflow-y: scroll !important;
    margin-right: -30px;
    padding-right: 40px;
  }
}
.clue-info-right::v-deep{
  .member-info{
    position: relative;
    .ant-form-item-label{
    width: 90px !important;
  }
  .ant-form-item-control-wrapper{
    padding-left: 90px !important;
    a{
      margin-right: 10px;
    }
    .clue-member-team{
      color: #b3b3b3;
    }
  }
  .hide-show-btn{
    position: absolute;
    right: 0;
    color: #D8D8D8;
    top: 6px;
    cursor: pointer;
    z-index: 10;
    transition: all 0.2s;
    &.clue-member-hide{
      transform: rotate(-90deg);
    }
  }
  }

  .clue-info-tool-btn{
    margin-left: 10px;
  }
}
</style>
